var map = {
	"./Hook 1.fbx": "894b",
	"./Mma Idle.fbx": "51b6",
	"./Praying Knee.fbx": "a8a8",
	"./Side Kick (2).fbx": "f052",
	"./Ymca Dance.fbx": "b409",
	"./control go backward.fbx": "c5ce",
	"./control go forward.fbx": "5e37",
	"./control go left.fbx": "b441",
	"./control go right.fbx": "3df4",
	"./control happy idle.fbx": "456f",
	"./control jog backwards.fbx": "9ba1",
	"./control natural idle.fbx": "c335",
	"./control run backwards.fbx": "2d37",
	"./control standing idle old.fbx": "0507",
	"./control standing idle old2.fbx": "7a89",
	"./control standing idle.fbx": "f4d0",
	"./control stay idle.fbx": "83e2",
	"./control step backward fight.fbx": "5280",
	"./control turn left 90.fbx": "61ac",
	"./control turn left a bit.fbx": "4e4f",
	"./control turn right 90.fbx": "d26a",
	"./control turn right a bit.fbx": "49b1",
	"./football jog backward diagonal (2).fbx": "fea3",
	"./football jog backward diagonal.fbx": "eeed",
	"./football jog forward diagonal (2).fbx": "ef2e",
	"./football jog forward diagonal.fbx": "083c",
	"./general walking.fbx": "2852",
	"./jump over.fbx": "059e",
	"./jump.fbx": "7eb9",
	"./left strafe.fbx": "4161",
	"./right strafe.fbx": "9e80",
	"./running.fbx": "833b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb7f";